import * as React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';

import {App} from '../../../types/commons';
import {Image} from '../../components/Image/Image';
import {LaunchApp} from '../../../store/partials/Directory';

import * as Styles from './PinnedApplicationTile.module.scss';

interface PinnedApplicationProps {
    item: App;
    onClick: (app: App) => void;
}

const PinnedApplicationTileComponent = React.forwardRef<HTMLElement, PinnedApplicationProps>((props, ref) => {
    const {item, onClick} = props;
    const handleLaunchApp = () => {
        onClick(item);
    };

    return (
        <div ref={ref as React.Ref<HTMLDivElement>} onClick={handleLaunchApp}>
            <Image title={item.title} src={item.icon} className={Styles['icon']}/>
        </div>
    );
});

const mapDispatch = (dispatch: Dispatch) => ({
    onClick: (app: App) => dispatch(new LaunchApp(app))
});

export const PinnedApplicationTile = connect(undefined, mapDispatch, undefined, {forwardRef: true})(PinnedApplicationTileComponent);
